import React from 'react';
import { useTranslation } from 'react-i18next';
import { Modal as MaterialModal } from '@material-ui/core';

import Button from 'src/components/Button/Button';

interface AllowPayoutInterface {
  onSubmit: () => Promise<void>,
  onClose: () => void,
  type: string
}

function AllowPayout({ onSubmit, onClose, type }: AllowPayoutInterface) {
  const { t } = useTranslation();

  return (
    <MaterialModal
      disableEscapeKeyDown={ true }
      open={ true }
      onClose={ onClose }
      className="modal"
    >
      <div className="modal-container">
        <div className="cancel-ticket__modal">
          { type === 'allow' && <h3 className="cancel-ticket__title">{ t('retail.confirmPayout') }</h3> }
          <h3 className="cancel-ticket__subtitle">{ type === 'allow' ? t('retail.continueAnyway') : t('retail.balanceTooLow') } </h3>
          <div className="cancel-ticket__buttons">
            {
              type === 'allow' && <Button
                type="button"
                text={ t('ticketDetails.confirm') }
                className="btn btn--cta"
                onClick={ onSubmit }
              />
            }
            <Button
              type="button"
              text={ t('endShift.cancel') }
              className="btn btn--cta cancel-ticket__button cancel-ticket__button--cancel"
              onClick={ onClose }
            />
          </div>
        </div>
      </div>
    </MaterialModal>
  );
}

export default AllowPayout;
